(function ($) {
  function toggleAccordion(toggle) {
    toggle.parent('.accordion').toggleClass('open');
    if (toggle.parent('.accordion').hasClass('open')) {
      toggle.next('.accordion-content').slideDown();
      toggle.parent('.accordion').attr('aria-expanded', true);
    } else {
      toggle.next('.accordion-content').slideUp();
      toggle.parent('.accordion').attr('aria-expanded', false);
    }
  }
  $(document).ready(function () {
    if ($(".accordion").length > 0) {
      $('.accordion.open > .accordion-content').slideDown();
      $(document.body).on('click', '.accordion-toggle', function () {
        toggleAccordion($(this));
      });
    }
  });
})(jQuery);